import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { ObservableService } from '@app/core/services/observable.service';
import { Subscription } from 'rxjs';
import { TranslateService } from "@ngx-translate/core";
import { TreeModel } from "@components/tree/tree.model";

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnInit, OnDestroy, OnChanges {
    @Input() displayField = '';
    @Input() label = '';
    @Input() labelClass = {};
    @Input() hasContextMenu = false;
    @Input() selectionMode = 'single';
    @Input() selectedFile;
    @Input() scanningEnabled = false;
    @Input() emptyMessage = '';
    @Input() loading = false;
    @Input() selectDisabled = false;
    @Input() propagateSelectionUp = true;
    @Input() propagateSelectionDown = true;
    @Input() isMaterial = true;
    @Input() isScanListenerActive = false;
    @Input() parameters = [];
    @Input() noToolsMessage = '';
    @Input() allExpanded = false;

    @Output() scan = new EventEmitter<any>();
    @Output() unselect = new EventEmitter<any>();
    @Output() select = new EventEmitter<any>();
    @Output() selections = new EventEmitter<any>();
    @Output() rowAlertClick = new EventEmitter<any>();
    @Output() parameterIconClick = new EventEmitter<any>();

    _contextMenuItems = [];
    _items = [];
    _selectedItems = [];
    toolsLoadingSubscription: Subscription;

    constructor(toolsLoadingService: ObservableService,
                private translateService: TranslateService) {
        this.toolsLoadingSubscription = toolsLoadingService.lodingTools$.subscribe(
            () => {
                this.emptyMessage = this.noToolsMessage;
                this.scanningEnabled = false;
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items) {
            if (this.allExpanded) {
                this.expandAll();
            }
        }
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.toolsLoadingSubscription.unsubscribe();
    }

    triggerScanEvent(event) {
        this.scan.emit(event);
    }

    nodeSelect(event) {
        this.selections.emit(this.selectedItems);
        this.select.emit(event);
    }

    nodeUnselect(event) {
        this.selections.emit(this.selectedItems);
        this.unselect.emit(event);
    }

    shouldRenderItems() {
        return this.items && this.items.length > 0;
    }

    get items() {
        return this._items;
    }

    @Input()
    set items(items) {
        this._items = items;
    }

    get contextMenuItems() {
        return this._contextMenuItems;
    }

    @Input()
    set contextMenuItems(items) {
        this._contextMenuItems = items;
    }

    @Input()
    set selectedItems(selectedItems) {
        this._selectedItems = selectedItems;

    }

    get selectedItems() {
        return this._selectedItems;
    }

    clickRowAlert(node) {
        this.rowAlertClick.emit(node);
    }

    onParameterIconClick(node: any) {
        this.parameterIconClick.emit(node);
    }

    getValue(node: any, parameter: any) {
        if (node.data[parameter.value] === undefined) {
            return null;
        }
        if (node.data[parameter.value]) {
            return node.data[parameter.value];
        }
        if (parameter.noValueMessage) {
            return this.translateService.instant(parameter.noValueMessage);
        }
        return null;
    }

    getLeafActionIcon(node) {
        if (!node.leaf) {
            return null;
        }

        const leafIcon = this.parameters.map(item => item.leafActionIcon);
        if (leafIcon && leafIcon.length) {
            return leafIcon[0];
        }
        return null;
    }

    expandAll() {
        this.items.forEach((node) => {
            this.expandRecursive(node, true);
        });
    }

    collapseAll() {
        this.items.forEach((node) => {
            this.expandRecursive(node, false);
        });
    }

    private expandRecursive(node: TreeModel, isExpand: boolean) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach((childNode) => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }
}
